import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { streamerMarketRestrictionsList } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import { mapActions } from 'vuex';
export default {
  name: "restrictionAnchorMarketList",
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      tableData: [],
      paramsData: {
        uid: '',
        page: 1
      },
      date: [],
      total: 0,
      exreqLoading: false
    };
  },
  created: function created() {// this.getList()
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.reqLoading = true;
                streamerMarketRestrictionsList(_this.paramsData).then(function (res) {
                  if (res.status == 200) {
                    var data = res.data;
                    _this.tableData = data.map(function (item) {
                      return {
                        uid: item
                      };
                    });
                    _this.total = res.data.total;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('playerId'),
        prop: 'uid'
      }];
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};